export default __webpack_public_path__ + "media/zurb/fonts/heroes_legend-webfont-078c7c6a1f2ecd57979f48ddd8cea9f7.woff2";